import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { BaseComponent, LoaderService, SystemDialogService } from 'sigv-library';
import { ExtranetAuthenticationService } from 'src/app/core/services/extranet-authentication.service';

@Component({
  templateUrl: './redirection.component.html',
  styleUrls: ['./redirection.component.scss'],
})
export class RedirectionComponent extends BaseComponent implements OnInit {
  private readonly destroy$ = new Subject<void>();

  constructor(
    injector: Injector,
    private extranetAuthenticationService: ExtranetAuthenticationService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private systemDialogService: SystemDialogService,
    private router: Router
  ) {
    super(injector);
  }

  ngOnInit(): void {
    const email = decodeURIComponent(this.route.snapshot.queryParams.email);
    const crossDomainSecret = decodeURIComponent(
      this.route.snapshot.queryParams.secret
    );
    const redirectTo = decodeURIComponent(
      this.route.snapshot.queryParams.redirectTo
    );
    const data = JSON.parse(
      decodeURIComponent(this.route.snapshot.queryParams.data)
    );

    this.extranetAuthenticationService
      .redirectLogin(email, crossDomainSecret)
      .subscribe({
        next: ({ isSuccess, msg, rtnCode }) => {
          this.loginHandler(isSuccess, msg, rtnCode, redirectTo, data);
        },
        error: () => {
          this.loginHandler(false);
        },
      });
    this.loaderService.stop();
  }

  loginHandler(
    isSuccess: boolean,
    msg?: any,
    rtnCode?: number,
    redirectTo?: string,
    data?: any,
  ): void {
    if (isSuccess) {
      if (redirectTo === "/notification/redirection") {
        const dataStr = JSON.stringify(data);
        const encodeData = encodeURIComponent(dataStr);
        this.router.navigate([redirectTo], {
          queryParams: { data: encodeData },
        });
      } else {
        this.router.navigate([redirectTo], data);
      }
    } else if (msg) {
      if (rtnCode === 99) {
        this.systemDialogService.showErrorDialog(
          [
            {
              description: this.translateService.instant(
                'Login.EnterErrorThreeTimes'
              ),
            },
          ],
          'Error'
        );
      } else {
        this.systemDialogService.showErrorDialog(
          [
            {
              description: this.translateService.instant(
                'Login.AccountOrPasswordIncorrect'
              ),
            },
          ],
          'Error'
        );
      }
    } else {
      const loginFailTitle = this.translateService.instant('SigvLibrary.Error');
      const loginFailMessage = this.translateService.instant(
        'SigvLibrary.LoginFail'
      );
      this.systemDialogService.showErrorDialog(
        [
          {
            description: loginFailMessage,
          },
        ],
        loginFailTitle,
        () => {
          // do logout clear all login data and logout azure ad
          this.router.navigate(['/logout']);
        }
      );
    }
  }
}
